import { render } from "./tabButton.vue?vue&type=template&id=2edaadad&scoped=true"
import script from "./tabButton.vue?vue&type=script&lang=js"
export * from "./tabButton.vue?vue&type=script&lang=js"

import "./tabButton.vue?vue&type=style&index=0&id=2edaadad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edaadad"]])

export default __exports__